
    // THIS FILE IS AUTO-GENERATED via 'yarn build-trans' !!

    export default {
        locale: 'en_GB',
        messages: {
			"graphical_template": "Graphic template",
			"fill": "Fill",
			"none": "None",
			"shape_color": "Fill color",
			"shape_position": "Position",
			"shape_size": "Size",
			"triangle": "Triangle",
			"square": "Square",
			"square_format": "Square format",
			"wide": "Wide",
			"width": "Width",
			"stroke_width": "Stroke width",
			"stroke_color": "Stroke color",
			"text_stroke_width": "Text stroke width",
			"text_stroke_color": "Text stroke color",
			"frame_image": "Frame image",
			"color": "Color",
			"side": "Side",
			"text": "Text",
			"text_color": "Text color",
			"text_fontsize": "Text size",
			"text_font": "Font",
			"triangle_orientation": "Triangle orientation",
			"search": "Search",
			"up": "Up",
			"down": "Down",
			"show_frame": "Show frame",
			"dashed": "Dashed",
			"frame_color": "Frame color",
			"frame_width": "Frame width",
			"frame_width_placeholder": "Frame width in pixel",
			"show_stripe": "Show stripe",
			"stripe_color": "Stripe color",
			"stripe_position": "Stripe position",
			"horizontal": "Horizontal",
			"vertical": "Vertical",
			"stripe_text_placeholder": "Text in stripe",
			"shape_text_placeholder": "Text in shape",
			"text_size_placeholder": "font size",
			"text_font_placeholder": "font",
			"nav_queries": "Product selections",
			"nav_size": "Format",
			"nav_frame": "Frame",
			"nav_filter": "Filter",
			"nav_stripe": "Stripe",
			"nav_shape": "Layer",
			"nav_image": "Image",
			"nav_save": "Save",
			"nav_shapes": "Layers",
			"upscale_image": "Upscale resolution",
			"template_type_null": "Graphic template",
			"template_type_1": "Upscale resolution",
			"template_type_2": "Remove background",
			"template_type_3": "Watermarks removal",
			"template_type_4": "Outpainting",
			"template_type_5": "Animated GIF",
			"template_type_6": "Inpainting",
			"template_type_10": "Image with watermark removed",
			"template_type_11": "Image with background removed",
			"template_type_1_started": "Image enhancement in progress",
			"template_type_2_started": "Background removal in progress",
			"template_type_3_started": "Watermark removal in progress",
			"template_type_4_started": "Outpainting in progress",
			"template_type_6_started": "Inpainting in progress",
			"template_type_1_done": "Image upscaled",
			"template_type_2_done": "Image background removed",
			"template_type_3_done": "Watermark removed",
			"template_type_4_done": "Outpainting done",
			"template_type_6_done": "Inpainting done",
			"outpainting_error": "Outpainting error",
			"outpaint_over": "Outpaint over full canvas",
			"upscale_previews_all_done": "Previews were generated. For bulk upscale select the product selection in right panel. Don't forget to name and save the template.",
			"min_detection_accuracy": "min detection accuracy",
			"min_detection_accuracy_info": "if the detection accuracy is lower, the original watermarked image will be kept",
			"get_previews": "Get previews",
			"select_images_for_upscale_previews": "To create previews, select the images and tap generate previews.",
			"creating_upscale_previews": "Generating previews. This process is time consuming, it will take a while.",
			"sending_images_for_upscale_previews": "Uploading images",
			"original_image": "Original image",
			"other_images": "Other Images",
			"bgremoved_image": "Edited image with background removed",
			"bgremoved_edited_image": "Image with background removed",
			"wmremoved_image": "Image with watermark removed",
			"upscaled_image": "Upscaled image",
			"no_images_for_upscale": "There are no images with dimensions up to 600 x 600 pixels. Upscale is not necessary.",
			"upscale_template": " Image upscaler",
			"upscale_how_does_it_work": "<h3>How does it work?</h3><p>The upscale method is based on ....</p>",
			"upscale_method_preview": "Upscale previews",
			"image_is_upscaled": "The upscaled image",
			"show_larger_preview": "Show larger preview",
			"upscale_loading_products": "Analyzing dimensions of images. Upscale makes sense for images with dimensions up to 600 x 600 pixels only.",
			"upscale_clear_interval": "Cancel and select other images",
			"clear_selection": "Deselect",
			"selected_count": "Selected",
			"cancel": "Cancel",
			"position": "Position",
			"opacity": "Opacity",
			"apply_on_queries": "Apply on products",
			"template_name": "Template name",
			"template_type": "Type",
			"save_template": "Save template",
			"show_shape": "Show layer",
			"stroke_opacity": "Stroke opacity",
			"priority": "Priority",
			"template_list": "Template list",
			"products": "Products",
			"images": "Images",
			"count_images": "count images",
			"validations": "Images validations",
			"new_template": "New template",
			"new_upscale_template": "Image upscaler",
			"new_bgremove_template": "Background removal",
			"new_wmremove_template": "Watermark removal",
			"template_gallery": "Template gallery",
			"blank_template": "Blank template",
			"background_color": "Background color",
			"text_background_color": "Background color",
			"background_width": "Width",
			"background_height": "Height",
			"background_type": "Background type",
			"background_type_none": "None",
			"background_type_circle": "Circle",
			"background_type_rectangle": "Rectangle",
			"background_type_rectangle-each-line": "Rectangle per each line",
			"background_type_ellipse": "Ellipse",
			"background_type_image": "Image",
			"random_product": "Random Product",
			"stroke": "Stroke",
			"full": "Full",
			"no_templates": "You don't have any templates yet. Let's create a first one!",
			"no_alternative_templates": "You don't have any alternative templates yet.",
			"all_products": "All products",
			"back": "Back",
			"back_to_template_list": "Back to template list",
			"due_date": "Due date",
			"created_at": "Created at",
			"save": "Save",
			"save_and_exit": "Save and exit",
			"save_and_apply": "Save and apply",
			"save_as_new_template": "Save as new template",
			"apply": "Apply",
			"saving": "saving",
			"no_shape_selected": "No layer selected.",
			"user": "User",
			"delete": "Delete",
			"insert": "Insert",
			"preview": "Preview",
			"pause": "Pause",
			"start": "Start",
			"action": "Action",
			"edit": "Edit",
			"next": "Next",
			"previous": "Previous",
			"project": "Export",
			"eshop": "Online store",
			"agency": "Agency",
			"freelancer": "Freelancer",
			"title": "Title",
			"date": "Date",
			"created_by": "Created by",
			"max_length": "Maximum length: 1000 characters",
			"chars_left": "Characters left",
			"monday": "Monday",
			"tuesday": "Tuesday",
			"wednesday": "Wednesday",
			"thursday": "Thursday",
			"friday": "Friday",
			"saturday": "Saturday",
			"sunday": "Sunday",
			"mon": "Mon",
			"tue": "Tue",
			"wed": "Wed",
			"thu": "Thu",
			"fri": "Fri",
			"sat": "Sat",
			"sun": "Sun",
			"yes": "Yes",
			"no": "No",
			"currency": "CZK",
			"filter": "Filter",
			"calcel_filter": "Cancel filter",
			"name": "Name",
			"confirm_delete": "Do you really want to delete this template?",
			"margin": "Margin",
			"add_shape_button": "New Layer",
			"add_shape": "Add new layer",
			"shape_list": "List of layers",
			"diameter": "Diameter",
			"active": "Active",
			"active_from": "Active from",
			"active_to": "Active to",
			"inactive": "Inactive",
			"set_active_date": "Template scheduler",
			"timer": "Timer",
			"invalid_active_date_range": "Invalid date range",
			"circle": "Circle",
			"frame": "Frame",
			"rectangle": "Rectangle",
			"triangle1": "Triangle",
			"triangle2": "Triangle",
			"triangle_side_length": "Side length",
			"corner_radius": "Border radius",
			"dynamicText": "Feed element",
			"imageFromElements": "Image from element",
			"curvedText": "Text along path",
			"circleText": "Text along circle",
			"textWithElements": "Text with elements",
			"background_settings": "Background settings",
			"text_wrap": "Text wrap",
			"text_overflow": "Text overflow",
			"text_overflow_keep": "unchanged",
			"text_overflow_fontsize": "decrease fontsize",
			"text_overflow_layersize": "enlarge layer",
			"text_decoration": "Decoration",
			"text_decoration_color": "Decoration color",
			"text_decoration_linethickness": "Line thickness",
			"text_decoration_lineoverlap": "Line overlap",
			"text_decoration_none": "none",
			"text_decoration_underline": "underline",
			"text_decoration_overline": "overline",
			"text_decoration_linethrough": "line-through",
			"text_direction": "Text direction",
			"text_align": "Text align",
			"text_align_left": "Left",
			"text_align_right": "Right",
			"text_align_center": "Center",
			"text_valign": "Vertical align",
			"text_valign_start": "Start",
			"text_valign_middle": "Middle",
			"text_valign_end": "End",
			"height": "Height",
			"aspect_size_ratio": "Maintain aspect ratio",
			"dash_length": "Dash lenght",
			"dash_density": "Dash density",
			"dashedFrame": "Dashed frame",
			"coordinate_x": "Coordinate x",
			"coordinate_y": "Coordinate y",
			"template_saved": "Template saved.",
			"upload_error_unsupported_type": "Unsupported file type",
			"upload_error_large_file": "Image file is too big. Max. size is 1MB.",
			"upload_error_image_too_big": "The image size is too big. Please resize the image and try again.",
			"active_templates": "Active templates",
			"type": "Type",
			"file_too_big": "File is too big. Maximum size is 0,5 MB",
			"file": "File",
			"bitmap": "Image",
			"polygon": "Polygon",
			"bezier": "Curve",
			"line": "Line",
			"line_cap": "Line Cap",
			"line_join": "Line Join",
			"line_cap_round": "round",
			"line_cap_inherit": "-",
			"line_cap_butt": "butt",
			"line_cap_square": "square",
			"line_join_inherit": "-",
			"line_join_miter": "miter",
			"line_join_round": "round",
			"line_join_bevel": "bevel",
			"collage_layouts": "Collages",
			"add_layout_button": "Custom",
			"save_as_new_collage": "Save as new collage",
			"preview_for_format": "Preview for format",
			"no_custom_sets": "You have no custom image sets yet",
			"custom_image_set_add": "Create image set",
			"custom_image_set_remove": "Delete image set",
			"custom_image_set_remove_image": "Delete image from set",
			"custom_image_set_selected_image": "Selected image",
			"custom_image_set_selected": "Images from set",
			"custom_set_name": "Custom set name",
			"custom_image_set_no_set_selected": "Select image set",
			"custom_image_set_no_images_yet": "There are no images in this set.",
			"custom_image_set_no_image_selected": "No image selected",
			"custom_image_set_uploaded": "The image was uploaded",
			"custom_image_set_cannot_remove_is_used": "The image is used in a template! It cannot be removed.",
			"custom_image_set_cannot_remove_success": "The image was deleted.",
			"custom_image_set_deleted_success": "The image set was deleted.",
			"custom_image_set_delete_set_is_used": "This image set cannot be deleted since some of the images from the set are used in templates.",
			"scale": "Scale",
			"adjust_size": "Product size customization",
			"enlarge": "Adjust dimensions",
			"no_enlarge_nor_crop": "no adjustment",
			"duplicate": "Duplicate the template",
			"horizontal_flip": "Flip horizontally",
			"vertical_flip": "Flip vertically",
			"flip": "Vertical",
			"flop": "Horizontal",
			"rotation": "Rotation",
			"elements": "Name of the attribute",
			"xml_element_name": "Attribute name",
			"rating_xml_element": "Rating element",
			"rating_count_xml_element": "Rating count element",
			"rating_max_value": "Maximum value in a rated element",
			"rating_hide_empty": "Only if all elements from the feed are available",
			"rating_min_stars": "Show ratings from",
			"no_rating_yet": "No one has reviewed this product yet",
			"empty_element": "<EMPTY ATTRIBUTE>",
			"imagick_fonts": "Font",
			"imagick_fonts_family": "Filter font family",
			"imagick_fonts_style": "Style",
			"imagick_fonts_info": "Warning: some fonts used for dynamic content are not available in the live preview so the preview image may differ from the final image. Please, use the Preview button to display text in the selected font.",
			"render_preview": "Render preview",
			"rotate_right": "Rotate right",
			"rotate_left": "Rotate left",
			"image_enlargment": "Image enlargement",
			"format": "Format",
			"first": "First",
			"last": "Last",
			"previews": "Preview",
			"more_previews": "More Previews",
			"edit_template": "Edit template",
			"no_templates_this_size": "You have no template of this size yet",
			"all_templates": "All templates",
			"reload_images": "Reload images",
			"show_unmodified": "Show original",
			"show_modified": "Show modified",
			"help": "Help",
			"manage_templates": "Manage templates",
			"inactive_templates": "Inactive templates",
			"show_template": "Show templates",
			"no_image": "Product has no image.",
			"active_templates_only": "Active templates only",
			"unmodified_images": "Original images",
			"allow_cache": "Allow cache",
			"no_products_in_query": "The product queries for this template are empty. We display a random product from your feed.",
			"size_format": "Size",
			"add_new": "Add new",
			"new": "New",
			"format_name": "Format name",
			"select_format": "Select the output formats...",
			"query_is_required": "You have to choose at least one product query",
			"format_name_is_required": "You have to fill the format name",
			"width_is_required": "Width must be more than 0",
			"height_is_required": "Height must be more than 0",
			"bad_file_format": "Wrong file format",
			"name_is_required": "You have to fill the template name.",
			"error_loading_image": "An error occured during image loading",
			"confirm__bulk_delete": "Do you really want to delete selected templates?",
			"svg_change_colors": "Change colors",
			"apply_color_change": "Apply color change",
			"load_image_error": "Failed to load the image.",
			"badge": "Badge",
			"badges": "Badges",
			"icons": "Icons",
			"search_badges_or_icons": "Search for graphic elements or icons",
			"tags": "Tags",
			"emoji": "Emoji",
			"change": "Change",
			"summer": "Summer",
			"borders": "Borders",
			"rating": "Rating",
			"rating_source": "Rating source",
			"xml_element": "XML element",
			"depots_extension": "Depots extension",
			"depots_not_enabled": "To use Depots as a source of image ratings, activate it for free in the <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"rating_from_element": "Product ratings",
			"star_symbol": "Star symbol",
			"active_only": "Active only",
			"dynamic_only": "Dynamic only",
			"autumn": "Autumn",
			"showroom": "Templates previews",
			"translate": "Translation",
			"crop": "Crop image",
			"image_format": "Product image size",
			"enlarge_hint": "Product image size is adjusted to always fill the requested format (while keeping the aspect ratio).",
			"crop_hint": "If the product image is bigger than the set format, it will be automatically cropped.",
			"winter": "Christmas",
			"vertical_align_center": "Center vertically",
			"horizontal_align_center": "Center horizontally",
			"enlarge_by": "Enlarge image by",
			"by_width": "width",
			"by_height": "height",
			"by_smaller": "smaller dimension",
			"by_bigger": "bigger dimension",
			"by_fit": "fit the output dimensions",
			"max_image_width": "Max image width (px)",
			"max_image_height": "Max image height (px)",
			"by_max_size": "Set max size (px)",
			"by_overscan": "Set Overlap (px)",
			"overscan": "Protection zone",
			"overscan_hint": "Here you can set by how many pixels the image should be reduced compared to the size of the original format. You can set a positive or negative value here. With a positive value, you achieve framing of the original image with the set background color, negative magnification.",
			"enlarge_by_hint": "Here you can choose according to which dimension should images be adjusted to format size. All source images always keep the aspect ratio.",
			"enlarge_by_blog_link": "A more detailed explanation",
			"error_save_template": "An error occured while trying to save template",
			"free-delivery": "Free delivery days",
			"black-friday": "BLACK FRIDAY   &   CYBER MONDAY",
			"valentine": "Valentine's Day",
			"easter": "Easter",
			"generic": "Generic templates",
			"source_image": "Source image",
			"sourceImage": "Source image",
			"edit_shape": "Edit layer",
			"new_shape": "New layer",
			"modal_close": "Close",
			"done": "Done",
			"general_error": "Error",
			"validation_error_fields.queries": "No products selected.",
			"validation_error_fields.shapes": "Template is empty.",
			"validation_error_queries": "No products selected.",
			"validation_error_size.id": "No image format selected.",
			"validation_error_name": "Name is empty",
			"validation_error_setName": "Set name cannot be empty",
			"validation_error_visual_similarity_templateids": "Select the templates in which you want to search for similar products.",
			"shape_name": "Layer name",
			"shape_badge_set_change": "Select another set",
			"delete_shape": "Delete layer",
			"edit_done": "OK",
			"loading": "Loading...",
			"low_contrast": "Low contrast",
			"same_image_in_preview": "Same product in preview",
			"processed_at": "Processed on",
			"total_processed": "processed",
			"with_status_ok": "without error",
			"with_status_error": "with error",
			"without_images": "without images",
			"image_link": "Image link",
			"content_length": "Content length",
			"probability": "Probability",
			"showGroup": "Group",
			"user_set": "Set by user",
			"status_code": "status code",
			"error": "error",
			"status_null": "?",
			"status_0_0": "Unavailable at the time of processing",
			"status_200_0": "Status ok",
			"status_200_null": "Status ok",
			"status_200_1": "Zero size image",
			"status_200_435": "Template file missing",
			"status_200_425": "Too Early",
			"status_200_450": "Unknown format",
			"status_500_0": "Internal server error",
			"status_503_0": "Service Unavailable",
			"status_400_0": "Bad Request",
			"status_404_0": "Page not found",
			"status_404_null": "Page not found",
			"status_403_0": "Forbidden",
			"status_200_420": "Unknown format",
			"status_429_0": "Too Many Requests",
			"status_200_465": "Width or height exceeds limit",
			"status_too_many_alts": "Too many alternative images",
			"status_same_images": "Products with the same image",
			"status_empty_images": "Missing images",
			"status_empty_images_description": "Your XML feed is missing the IMGURL tag for your products. Products are not linked to images, or image files are completely missing. As a result, they will not appear in your online store or comparison shopping engines.",
			"status_unavailable_description": "The web page where the images are stored could not be found.",
			"status_unsupported_mime_type_description": "The file format to which the URL refers does not belong to the standard image format. Product images will not appear in your store.",
			"status_invalid_url_description": "Product images can be rejected by the comparison engine if their URL is too long or contains characters that are not allowed by the criteria. A common problem is accents or spaces in the image name.",
			"has_watermark_description": "If you're protecting your product images with watermarks, be aware that advertising systems like Heureka, GLAMI, FAVI and Google Shopping won't show you these products.",
			"status_wrong_placement_description": "Ideally, the products in the image should be as flat as possible and centered. Otherwise, the information value is lost, and they appear inconsistent.",
			"status_poor_quality_images_description": "If your product images aren't sharp enough, contain glitches, or are otherwise blurred, they may deter customers by their poor quality.",
			"status_seo_large_file_description": "<h3>The recommendation description:</h3> The size of the images exceeds the limit of 400 kB. It harms your online store, as they take a long time to load. It can lead to an increased dropout rate. <br/><h3>The solution detail:</h3> Feed Image Editor bulk compresses oversized images to reduce their size so that they load faster on the web. You can read more in the article on <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/improve-image-seo-automatic-compression\")>our blog</span>.",
			"status_few_alt_images_description": "<h3>Detailed description of the problem:</h3> The comparison engines where you want to advertise allow you to display alternative images for your products. There is no single alternative image available for the following products.<br/><h3>Solution:</h3> Add alternative images to the feed and make the most of the comparison engines. Learn how to find images for products in our blog article.",
			"status_transparent_background_description": "The white background of product images is an unwritten standard for most advertising systems and comparison engines. If some of your images have a transparent background, they will be rejected, or the background automatically fills in and looks gritty.",
			"status_same_images_description": "Some products have the same images, e. g. for clothing sizes, car parts, and intangible products. In other cases, it does not make a good impression.",
			"alternative_images_description": "Your products have too many alternative images. Images over this threshold will not be displayed in the comparison engine. Take this into account and advertise the most attractive alternative images only.",
			"status_poor_quality_images": "Image quality",
			"status_seo_large_file": "The size of the image file in terms of SEO",
			"status_few_alt_images": "Option to add alternative images",
			"status_all": "All products",
			"status_unavailable": "Status unavailable",
			"status_invalid_url": "Invalid URL characters",
			"status_unsupported_mime_type": "Unsupported file format",
			"status_wrong_placement": "Position, alignment and product image size",
			"status_transparent_background": "Transparent background",
			"unsupported_mime_by_engines": "Images not supported by comparison engine: Export file format is not supported by the comparison engine. Change file format in app settings.",
			"supports_formats": "supports formats",
			"with_problems": "with errors",
			"clear_old_products": "Clear old products in db",
			"info_is_new": "No imported products yet. It seems the rules in this export were not applied yet.",
			"info_no_data": "No products seem to match your filters.",
			"info_not_processed_yet": "Image processing and diagnostics run continuously throughout the day.",
			"info_apply_one_rule": "If you have multiple templates for the same products, only the highest priority template is applied. You can assign products for each template when editing the template on the Products tab.",
			"filter_image_url": "Image url",
			"filter_product_url": "Product url",
			"filter_product_urls": "Product urls",
			"fulltext": "Full-text search",
			"input_list": "Enter multiple addresses separated by commas or carriage returns",
			"more": "More",
			"less": "Less",
			"filter_status_code": "Status code",
			"filter_template": "Template",
			"filter_from": "Date from",
			"filter_to": "Date to",
			"filter_productname": "Product name",
			"filter_productid": "Product MERGADO id",
			"filter_element": "Attribute",
			"filter_element_value": "Attribute value",
			"filter_value_from": "From",
			"filter_value_to": "To",
			"filter_add": "Element",
			"filter_remove": "Remove <br/>all filters",
			"filter_group": "Group",
			"filter_content_type": "Image format",
			"filter_content_length": "Length",
			"custom_filter": "Custom filter",
			"preset_ranges": "Preset ranges",
			"filter_mistake_set_by_user": "User-set status",
			"filter_correctness_percentage_offset": "Distance to edge",
			"filter_has_alpha": "Has Alpha",
			"filter_status_reason": "Status Reason",
			"filter_status": "Status",
			"filter_probability": "Probability of watermark occurence [%]",
			"filter_user_set_watermark": "Image with watermark (user)",
			"filter_user_set": "User-set status",
			"watermarks": "Watermarks",
			"images_quality": "Quality status",
			"quality_status": "Images Quality",
			"bad_quality_score": "Bad quality score",
			"good_quality": "Good",
			"bad_quality": "Bad",
			"middle_quality": "Medium",
			"diagnostics": "Diagnostics",
			"processed_alt_images": "Processed alternative images",
			"processed_images": "Processed images",
			"problems": "Problems",
			"warnings": "Warnings",
			"recommendations": "Recommendations",
			"overview": "Overview",
			"watermarks_removal": "Watermarks removal",
			"selected_watermark_pattern": "This image will be used as a pattern for the watermark you are looking for",
			"select_watermark_pattern": "Add to watermarkMasks containing a watermark",
			"user_set_objects": "User-marked watermark positions",
			"with_or_without_objects": "Marked watermarks",
			"with_objects": "With marked watermarks",
			"without_objects": "Without marked watermarks",
			"all": "All",
			"view_mode": "View",
			"problems_text": "For so many products, <b>the product images do not display</b>, because at least one of the following issues has occurred:",
			"warnings_text": "For so many products, <b>there are limits on the display of your images</b>, because at least one of the following issues has occurred:",
			"recommendations_text": "For so many products, <b>the product images do not display</b>, because at least one of the following issues has occurred:",
			"one_product": "product",
			"less_than_five_products": "products",
			"products_count": "products",
			"image_id": "Image ID",
			"mistake_set_by_user": "Mistake set by user",
			"correctness_percentage_offset": "Distance to edge",
			"has_alpha": "Has Alpha",
			"status_reason": "Status Reason",
			"status": "Status",
			"updated_at": "Updated At",
			"no_alpha": "No",
			"with_alpha": "Yes",
			"info_status_suspicious": "Unable to detect whether the image is intentionally in this position",
			"vertical_image": "Vertical image",
			"horizontal_image": "Horizontal image",
			"image_down": "Image down",
			"image_up": "Image up",
			"image_right": "Image right",
			"image_left": "Image left",
			"image_in_the_middle": "Image in the middle",
			"image_could_not_be_read": "Image couldn't be read",
			"unknown_image_format": "Unknown image format",
			"option_false": "No",
			"option_true": "Yes",
			"option_not_set": "Value not set",
			"mistake_by_user_successfully_changed": "Value changed",
			"status_N/A": "Suspicious",
			"status_ERROR": "Error",
			"status_OK": "OK",
			"status_NOT_OK": "Not OK",
			"status_NOT_DETECTED": "Not detected",
			"importance_HIGH": "High",
			"importance_MEDIUM": "Medium",
			"importance_SMALL": "Low",
			"filter_is_active": "filter is active",
			"export_to_csv": "Export",
			"csv_download_started": "Generating CSV file, please wait",
			"csv_download_success": "The file was successfully created",
			"csv_download_error": "An error occurred while exporting to CSV",
			"shop_link": "Link to online store",
			"unmodified_link": "Original image",
			"modified_link": "Modified image",
			"total_products": "Products",
			"total_images": "Images",
			"total_alt_images": "Alternative images",
			"total_products_info": "Total number of products imported from MERGADO",
			"no_products_yet": "No imported products for this template yet.",
			"total_processed_products_info": "Total pre-processed products.",
			"product": "Product",
			"product_category": "Category",
			"product_links": "Links",
			"eshop_product": "Product in online store",
			"barcode_lookup": "Product in BarcodeLookup",
			"product_name": "Product",
			"product_no": "Product number",
			"product_code": "Product code",
			"product_image": "Image",
			"product_template": "Template",
			"product_image_link": "Image url",
			"element_item_id": "Product ID",
			"element_url": "Link to online store",
			"element_cpc": "CPC",
			"element_name": "Product name",
			"element_img_url": "Output image address",
			"element_img_url_input": "Input image address",
			"element_alt_img_url": "Output alternative image link",
			"element_alt_img_url_input": "Input alternative image link",
			"element_price_vat": "Price with VAT",
			"element_delivery_date": "DELIVERY_DATE",
			"element_manufacturer": "Manufacturer",
			"element_categorytext": "Category",
			"element_ean": "EAN",
			"element_productno": "Product no",
			"element_accessory": "Accessory",
			"element_gift": "Gift",
			"element_itemgroup_id": "ITEMGROUP_ID",
			"advanced_search": "Advanced Search",
			"export_is_ready": "Export is ready. ",
			"download": "Download",
			"please_wait_generating_export": "Please wait, generating export",
			"please_wait_generating_export2": "This window can be closed. When the export is ready, you will get a notification with a download link.",
			"click_to_download_export": "To download the export, click the Download button",
			"exported": "Exported",
			"close": "Close",
			"n_products": "products",
			"template_exported": "Template exported",
			"export_template": "Export template",
			"import_template": "Import template",
			"link_image_url": "Image link",
			"link_fie": "Image from Feed Image Editor",
			"link_mergado": "Product in MERGADO",
			"link_eshop": "Product in online store",
			"template_not_found": "Template not found!",
			"template_preview": "Preview",
			"template_is_dynamic": "Template with dynamic elements",
			"input_width": "Input image width",
			"input_height": "Input image height",
			"product_content_type": "Image format",
			"product_content_length": "input size [kB]",
			"rendered_content_length": "output size [kB]",
			"copy_to_clipboard": "Copy to clipboard",
			"copy_mergado_query": "Copy MERGADO query to clipboard",
			"copied_to_clipboard": "copied",
			"products_per_page": "Products count on the previews page",
			"layer_copied": "The layer has been copied to the clipboard",
			"ask_save_before_leave": "Your changes might not be saved if you leave.",
			"ask_save_before_leave_title": "Leave without saving?",
			"ask_save_before_leave_leave": "Leave",
			"ask_save_before_leave_stay": "Stay",
			"history_undo": "Undo",
			"history_redo": "Redo",
			"history_initial": "Undo all",
			"settings": "Settings",
			"confirm_delete_format": "Delete this format",
			"confirm_delete_format_yes": "Yes",
			"confirm_delete_format_no": "No",
			"templates_having_this_size": "Templates with this format",
			"project_settings": "Project settings",
			"ui_settings": "User interface Settings",
			"output_image_format": "Output format settings",
			"output_image_compression": "Output image compression",
			"auto_compression_to_size": "Automatic compression to size",
			"group_by_image": "Group by image",
			"products_per_page_on_list": "Products per page",
			"ask_before_leave": "Ask before leaving editor to save changes",
			"settings_value": "value",
			"settings_update_success": "Settings saved",
			"settings_update_error": "There was an error while saving settings",
			"save_sizes_success": "Format saved",
			"save_sizes_error": "An error occurred while saving the format",
			"different_hash": "The data may not be up to date",
			"filtered_items": "Filtered items",
			"set_template_active_date_success": "Date set",
			"set_template_active_date_error": "Failed to set date",
			"from_date": "from",
			"to_date": "to",
			"is_active": "is active",
			"not_active": "is not active",
			"is_date_limited": "Active from - to",
			"active_now": "Active now",
			"set_timer": "Set the timer",
			"show_more": "More...",
			"show_less": "Less...",
			"output_image_preview": "Output image preview",
			"output_image_content_length": "Content length",
			"original_output_image_content_length": "Originally",
			"less_than_original": "less than originally",
			"more_than_original": "more than originally",
			"about": "about",
			"has_no_watermark": "With no watermark",
			"has_watermark": "Has watermark",
			"watermark_status": "Image with watermark",
			"hiding_products": "Hiding products",
			"hide_products_by_filter": "Hide products by filter",
			"unhide_products": "Un-hide",
			"hidden_by_filter": "Hidden by filter",
			"hide_by_has_watermark": "Hide products with watermarks",
			"hide_by_wrong_placement": "Hide products with wrong image placement",
			"hide_by_low_quality": "Hide low quality products",
			"hide_by_seo_large_file": "Hide products with a large image file in terms of SEO",
			"filter_content_length_gt": "Content length greater than ... [kB]",
			"filter_content_length_lt": "Content length smaller than ... [kB]",
			"set_by_user": "Set by user",
			"filter_empty_content": "Empty image content",
			"filter_no_image": "No image",
			"is_collage": "Layout",
			"all_available_only": "Only if all alternative images are available",
			"single_image": "Single product image",
			"collage_layout": "Choose layout",
			"export_layouts": "Export layouts",
			"import_layouts": "Import layouts",
			"export_gradients": "Export gradients",
			"import_gradients": "Import gradients",
			"main_image": "Image",
			"alt_image": "Alt",
			"alternative_images": "Alternative images",
			"save_layouts_error": "An error occurred while saving layouts",
			"save_layouts_success": "Saved",
			"delete_layouts_error": "An error occurred while deleting layout. The layout is used in the template.",
			"delete_layout_image_error": "Error deleting image from layout",
			"delete_layouts_success": "Deleted",
			"add_layout_image_success": "Image added to layout",
			"add_layout_image_error": "There was an error while adding the layout image",
			"create_default_layouts": "Re-create the default layout set",
			"create_default_layouts_success": "Default layout successfully created",
			"create_default_layouts_error": "Error creating default layout",
			"delete_all_unused": "Delete all unused",
			"delete_all_unused_success": "Deleted successfully",
			"delete_all_unused_error": "Error while deleting unused",
			"layout_name": "Layout name",
			"selected_layout_image": "Selected image",
			"add_layout": "Add layout",
			"delete_layout": "Delete layout",
			"delete_layout_image": "Delete layout image",
			"add_layout_image": "Add layout image",
			"save_all_layouts": "Save all layouts",
			"save_layout": "Save layout",
			"padding_px": "Layout padding [px]",
			"assigned_image": "Assigned image",
			"units": "Units",
			"layout_pos": "Relative pos",
			"layout_size": "Relative size",
			"add_layout_success": "Nové rozložení přidáno",
			"add_layout_error": "Došlo k chybě při přidávání rozložení",
			"template_sizes": "Output image size",
			"save_order": "Save settings order",
			"save_settings_order_success": "Setting order saved",
			"save_settings_order_error": "Error saving order",
			"import_template_success": "Template imported",
			"import_template_error": "Error while importing template",
			"representative_colors": "Representative colors from the image",
			"shortcuts": "Shortcut keys",
			"shortcut_ins": "Insert a new layer",
			"shortcut_del": "Delete layer",
			"shortcut_save": "Save template",
			"shortcut_undo": "Undo",
			"shortcut_redo": "Redo",
			"shortcut_copy": "Copy layer",
			"shortcut_paste": "Paste layer",
			"product_is_rendering": "Rendering preview",
			"product_is_loading": "Loading product",
			"is_saving": "Saving",
			"invalid_filed_value": "Invalid field value",
			"value_not_set": "not set",
			"font_not_found": "Font was not found. Changing to default.",
			"radius": "Radius",
			"gradient_type_linear": "Linear",
			"gradient_type_radial": "Radial",
			"no_gradient": "No gradient",
			"select_gradient": "Select gradient",
			"select_gradients": "Select gradients",
			"save_as_new_gradient": "Save as new gradient",
			"info_gradients_not_saved": "Gradient changes have not yet been saved",
			"gradient": "Gradient",
			"gradients": "Gradients",
			"confirm_remove_gradient": "Delete this gradient?",
			"palettes": "Color palettes",
			"predefined_colors": "Predefined colors",
			"brand_colors": "Brand colors",
			"custom_colors": "Custom color palettes",
			"select_palette": "Select palette",
			"extract_colors_from_image": "Extract the colors from the image",
			"add_to_custom_palettes": "Add to custom palettes",
			"save_custom_colors": "Save custom colors",
			"save_as_default": "Save as default",
			"saved": "Saved",
			"no_changes": "No changes",
			"no_custom_palettes": "You have no custom pallets yet",
			"create_layer_group": "Create a layer group",
			"group": "Group",
			"ungroup": "Ungroup",
			"delete_layer_group": "Un-group",
			"toggle_visibility": "Toggle visibility",
			"delete_layers": "Delete layers",
			"delete_layer": "Delete layer",
			"duplicate_layer": "Duplicate layer",
			"duplicate_layers": "Duplicate layers",
			"edit_layer": "Edit layer",
			"lock_layer": "Lock layer",
			"unlock_layer": "Unlock layer",
			"thickness": "Thickness",
			"brightness": "Brightness",
			"contrast": "Contrast",
			"show_products": "Show products",
			"reset_effects": "Reset effects",
			"auto_level": "Automatically adjust color levels of image",
			"alpha": "Transparency",
			"save_as_query": "Save as <br/> query",
			"save_as_query_title": "Save as query",
			"fie_query_type": "Type",
			"fie_query_name": "Query name",
			"fie_query_element": "Name of the new element in MERGADO",
			"fie_query_filter": "Products filter",
			"fie_query_is_active": "Active",
			"query_in_use": "This query is used in the template",
			"fie_queries": "Queries",
			"fie_queries_info": "Výběry - TODO: napověda",
			"no_fie_queries_yet": "You do not have any product selections yet. The selections can be created in the product section.",
			"toggle_active": "Toggle active/inactive",
			"set_active": "Toggle active",
			"set_inactive": "Toggle inactive",
			"image": "Image",
			"mergado_connection_verifying": "Checking connection with MERGADO",
			"show_in_mergado": "Show in MERGADO",
			"mergado_queries": "Queries",
			"mergado_products": "Products",
			"mergado_formats": "Formats",
			"mergado_elements": "Elements",
			"output_image_element": "Output image element",
			"output_image_hidden_warning": "Warning: the output image element for this type of export is hidden",
			"not_empty_error": "This field is required",
			"drop_shadow": "Shadow",
			"shadow_color": "Shadow color",
			"shadow_opacity": "Opacity",
			"shadow_sigma": "Blurring",
			"shadow_offset": "Displacement",
			"shadow_xoffset": "X",
			"shadow_yoffset": "Y",
			"effect_sensitivity": "Effect sensitivity",
			"sensitivity": "sensitivity",
			"LOW": "low",
			"MEDIUM": "medium",
			"HIGH": "high",
			"too_big_for_upscale": "The image is larger than 600 x 600 pixels, upscale cannot be applied. Please load another random image.",
			"only_main_image": "the main image only",
			"other_effects": "Other effects",
			"flood_fill_points": "Points",
			"fuzz": "Fuzz",
			"heureka_175x175": "Heureka – recommended dimensions",
			"heureka_4096x4096": "Heureka – maximum dimensions",
			"zoot_1000x745": "Zoot – minimum dimensions",
			"zoot_1907x2562": "Zoot – recommended dimensions",
			"zbozi_425x440": "Zboží.cz – minimum dimensions",
			"zbozi_600x800": "Zboží.cz – minimum dimensions (second-hand goods)",
			"google_100x100": "Google Merchants – minimum dimensions",
			"google_250x250": "Google Merchants – minimum dimensions for apparel images",
			"google_500x500": "Google Merchants – minimum dimensions *from 31 January 2027",
			"google_1500x1500": "Google Merchants – recommended dimensions",
			"glami_400x400": "GLAMI – minimum dimensions",
			"glami_1500x1500": "GLAMI – recommended dimensions",
			"alza_600x600": "ALZA – minimum dimensions",
			"alza_1000x1000": "ALZA – minimum recommended dimensions",
			"alza_1300x1300": "ALZA – maximum recommended dimensions",
			"favi_600x600": "FAVI – minimum dimensions",
			"favi_1000x1000": "FAVI – recommended dimensions",
			"biano_400x400": "BIANO – minimum dimensions",
			"biano_1500x1500": "BIANO – recommended dimensions",
			"shopalike_250x250": "Shopalike – minimum dimensions",
			"shopalike_1024x1024": "Shopalike – recommended dimensions",
			"instagram_1024x1024": "Instagram – recommended dimensions",
			"instagram_1080x1080": "Instagram",
			"instagram_1080x1350": "Instagram",
			"instagram_1080x566": "Instagram",
			"instagram_1080x1920": "Instagram",
			"instagram_1440x1800": "Instagram",
			"instagram_1440x2560": "Instagram",
			"allegro_500x500": "Allegro – minimum dimensions",
			"allegro_2560x2560": "Allegro – maximum dimensions",
			"facebook_1024x1024": "Facebook – recommended dimensions",
			"facebook_500x500": "Facebook – minimum dimensions",
			"facebook_600x600": "Facebook",
			"facebook_1080x1080": "Facebook",
			"facebook_1200x1200": "Facebook",
			"facebook_1080x1350": "Facebook",
			"facebook_1200x628": "Facebook",
			"facebook_1440x1440": "Facebook",
			"facebook_1440x1800": "Facebook",
			"facebook_1440x2560": "Facebook",
			"modio_500x500": "Modio – minimum dimensions",
			"modio_1024x1024": "Modio – recommended dimensions",
			"modio_2048x2048": "Modio – maximum dimensions",
			"mall_1280x1024": "Mall – minimum dimensions",
			"mall_2000x2000": "Mall – maximum dimensions",
			"kaufland_1024x1024": "Kaufland – minimum dimensions",
			"kaufland_2048x2048": "Kaufland – recommended dimensions",
			"snapchat_200x200": "Snapchat – minimum dimensions",
			"pinterest_200x300": "Pinterest – minimum dimensions",
			"pinterest_600x900": "Pinterest – minimum dimensions",
			"pinterest_1000x1500": "Pinterest – recommended dimensions",
			"pinterest_1080x1920": "Pinterest – recommended dimensions",
			"pinterest_1080x1080": "Pinterest",
			"find_format": "Find format",
			"custom_formats": "Custom formats",
			"other_formats": "Other formats",
			"elements_availability": "Availability of elements in dynamic templates",
			"product_elements": "Elements",
			"filter_missing_elements": "Filter missing or empty elements",
			"only_updated_products": "Only products updated by MERGADO rules after template was saved",
			"ok": "OK",
			"empty_elements": "Empty elements",
			"toggle_snap_to_guides": "Snap",
			"toggle_snap_to_grid": "Snap to grid",
			"toggle_snap_to_element": "Snap to element",
			"show_grid": "Grid",
			"snap_strength": "Snap strength",
			"is_anim_gif": "Animated GIF",
			"outpainting": "Outpainting",
			"frames_delay": "Delay between frames [ms]",
			"loops_delay": "Delay at the end of the loop [ms]",
			"info_no_active_template": "You currently have no templates active. Feed Image Editor starts working after you activate one.",
			"info_no_template": "<b>You have not created a template.</b><br/>Choose one of the ready-made templates from the gallery, or create your own.",
			"info_workshop": "Learn to use Feed Image Editor flawlessly. Sign up for the free image marketing workshop. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/workshop\")>Find out more</span>.",
			"replace_color": "Replace colors",
			"target_color": "Target color",
			"replace_by_color": "Fill color",
			"add_point": "Add point",
			"info_no_points": "You can add new points by clicking on the canvas",
			"projects_overview": "Projects overview",
			"system": "System",
			"project_info": "Project",
			"templates": "Templates",
			"random_images": "Random Images",
			"rules": "Rules",
			"queries": "Queries",
			"rabbit": "RabbitMQ",
			"points_coordinates": "Relative points position",
			"no_images_found": "No products containing images were found",
			"show_helper": "Show helper",
			"disable_helper": "Don't show helper",
			"disable_wheelzoom": "Disable mouse wheel zoom",
			"helper_ok": "Ok",
			"helper_close": "Do not show anymore",
			"helper": "Helper",
			"need_help_title": "Do you need help?",
			"need_help_text": "In case of any suggestions or problems, please contact our support <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"bezier_no_points": "<ul><li class=\"right-arrow-marker\">Click on the canvas to add a new curve point</li></ul>",
			"bezier_add_points": "<ul><li class=\"right-arrow-marker\">Click on the canvas, hold down the button and adjust the control points by dragging the mouse. Then release the button and you can set more points.</li></ul>",
			"bezier_unselect": "<ul><li>To change the active layer, you can use the right mouse button for active shape unselect or switch in the layer list.</li></ul>",
			"has_reflection": "Reflection",
			"angle": "Angle",
			"reflection_offset": "Offset",
			"reflection_opacity": "Opacity",
			"reflection_flip": "Flip",
			"helper_no_queries": "<ul><li class=\"info-marker\">Select the product query to which the template will be applied. Use a filter to find a selection.</li></ul>",
			"helper_one_query": "<ul><li>You can select multiple queries.</li></ul>",
			"helper_at_least_one_query": "<ul><li>You will always find the selected queries at the top of the list.</li></ul>",
			"helper_zero_products_query": "<ul><li class=\"exclamation-marker\">The selected query does not contain any products.</li></ul>",
			"helper_no_format": "<ul><li class=\"info-marker\">Select one of the output formats. You create your own format at the bottom of the list or in Settings.</li></ul>",
			"helper_format_selected": "<ul><li>Select the adjustment method.</li><li>Adjust the overlap manually as required.</li></ul>",
			"helper_no_layer": "<ul><li class=\"info-marker\">Click on the New Layer to add text, labels, graphics, and more to your images.</li></ul>",
			"helper_at_least_one_layer": "<ul><li>You can change the layers order by dragging {ArrowVIcon}.</li><li>The layers with the dynamic elements will be fixed on the top of the canvas.</li><li>Don't forget to name and save the template.</li></ul>",
			"helper_two_more_layers": "<ul><li>Press <span class=\"framed\">CTRL</span> and click on the multiple layers. You can select more layers and group them by {GroupIcon} into one layer. You can use the same button to ungroup the layer back.</li><li>Guide-lines make it easier for you to align the layers. You activate and deactivate the guidelines press {MagnetIcon} button.</li></ul>",
			"layers": "Layers",
			"brush_spacing": "Spacing",
			"brush_color": "Brush color",
			"brush_pattern": "Pattern",
			"brush_pattern_color": "Pattern color",
			"brush_rotate_pattern": "Rotate pattern",
			"linewidth_profile": "Line width profile",
			"uniform": "uniform",
			"fade_out": "fade out",
			"fade_in": "fade in",
			"fading": "fading both sides",
			"zoom_in": "zoom in",
			"zoom_out": "zoom out",
			"token_not_provided": "Authentication error - token not provided",
			"toast_online_call": "Not sure or need help creating your first image campaign? Make an <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>online call with Marek</span>,He will be happy to advise you on how to make the most of the Feed Image Editor.",
			"online_call_header": "Do you want help with setup or inspiration for your campaigns?",
			"online_call": "Book a short free consultation with Marek. He will show you best practices for your type of e-shop, help with the setup, and answer anything you want to know.",
			"watermark_mask": "Watermark mask",
			"watermark_masked_image": "Masked watermark image",
			"watermark_group": "Watermark group",
			"watermark_groups": "Watermark groups",
			"watermark_methods": "Watermark removal methods",
			"create_new_group": "Create new group",
			"new_group": "New group",
			"required_field": "Required field",
			"no_watermark_masks": "You have no watermarks marked yet",
			"downloaded": "Downloaded",
			"status_ok": "Status OK",
			"waiting_to_process": "Waiting to process",
			"inpaint_error": "Watermark removal error",
			"watermark_group_not_selected": "Please select the watermark group first",
			"background": "Background",
			"remove_background": "Remove background",
			"solid_bg": "Solid color",
			"light_bg": "Light background",
			"dark_bg": "Dark background",
			"background_colors": "Colors",
			"background_shade": "Background shade",
			"not_transparent_bg": "Not transparent",
			"transparent_bg": "Transparent background",
			"multicolor_bg": "Multicolor",
			"status_not_recommended_colorspace": "Color models",
			"not_recommended_colorspace": "Color models",
			"not_recommended_colorspace_description": "Your images are in a CMYK color model, which is not suitable for displaying on a computer and a mobile screen. Such images draw back your customers. Convert the images to an RGB color model.",
			"status_unsupported_background": "Image background",
			"unsupported_background": "Image background",
			"unsupported_background_description": "Comparison engines and advertising channels differ in background requirements for product images. Most of them require a monochrome white background. If you submit images or product photos with a colored background, you will not receive these products for advertising. On the contrary, it is possible to use colored background images or photos for some comparators.",
			"set_watermark_group_first": "Please set watermark group first!",
			"unknown_preview_image_error": "Error loading image",
			"render_preview_error_6": "Could not resolve host",
			"render_preview_error_1": "The source image is empty",
			"render_preview_error_420": "Unknown format",
			"render_preview_error_450": "PNG CRC error",
			"render_preview_error_28": "Failed to connect (operation timeout)",
			"render_preview_error_35": "SSL error: wrong signature type",
			"first_steps_wizard": "First setup guide",
			"skip_wizard": "I don't need a wizard, I want to go to the application",
			"close_wizard": "Close the wizard",
			"input_elements_map": "Input elements settings",
			"input_output_format": "Input and output format settings",
			"first_steps_create_template": "Done. Everything is ready for creating the first template.",
			"first_step_info": "Welcome to the Feed Image Editor application, which will help you bulk edit your e-shop's product images for marketplaces, social networks and comparison shopping.<br/>In the first step, please select the channel you want to advertise on:",
			"first_step_info_old": "Welcome to the Feed Image Editor app, which helps you edit images in your online store. <br/>As a first step, please make sure we have selected the correct elements from your feed for use in the editor. Then you can start creating the first template right away.",
			"next_step": "Next step",
			"previous_step": "Previous step",
			"input_format": "Input format",
			"output_format": "Output format",
			"preferred_product_preview": "Preferred product preview",
			"date_placeholder": "DD. MM. YYYY",
			"today": "Today",
			"news_box_header": "See what's new in the app",
			"news_box_body": "<h4>Edit product images right from your chat</h4><p>Feed Image Editor now has an MCP server – connecting AI assistants like Claude or ChatGPT directly to your editor. Instead of clicking through the interface, just type a request in chat and the agent will:<ul><li>set up templates and edit parameters</li><li>assign products based on a selection</li><li>resize images, remove backgrounds, upscale resolution</li></ul><p>If you already have an AI assistant connected via Mergado MCP, Feed Image Editor MCP works automatically – no extra setup needed. If you haven't worked with MCP yet, just click the link and connect it in a moment.</p>",
			"news_box_body_link": "Learn more →",
			"select_template_queries": "First, select which products you want to apply the template to",
			"set_output_image_size": "Set the size of the output images",
			"select_from_template_gallery": "You can choose one of our ready-made templates",
			"main_image_or_collage": "Choose whether you want to have only the main image or a collage of the main one and alternative images at the output",
			"main_image_on_canvas_placement": "Place the main image on the canvas",
			"set_collage_layout": "Set the collage layout. For a better effect, we recommend activating the background removal feature.",
			"set_anim_gif": "Set the final appearance of the animated GIF",
			"position_and_rotation": "Position and rotation",
			"apply_ai_effects_or_filters": "Apply AI effects or filters to the product image",
			"editor_step_5": "Choose whether the template should be launched immediately after creation or on the selected day",
			"editor_step_6": "Visual similarity of images",
			"editor_step_7": "Add more layers with graphic elements",
			"helper_tips": "<ul><li>Would you like to use your own font in the app? Contact support@feedimageeditor.com</li><li>Did you know you can use keyboard shortcuts in the editor?<div class='quote'><span class='framed'>Ins</span><span>Insert a new layer</span><br/><span class='framed'>Del</span><span>Delete layer</span><br/><span class='framed'>Ctrl + s</span><span>Save template</span><br/><span class='framed'>Ctrl + z</span><span>Undo</span><br/><span class='framed'>Ctrl + y</span><span>Redo</span><br/><span class='framed'>Ctrl + c</span><span>Copy layer</span><br/><span class='framed'>Ctrl + v</span><span>Paste layer</span></div></li></ul>",
			"more_fonts": "Would you like to use your own font in the app? Contact <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"editor_step_0": "Select template type",
			"layout": "Image Layout",
			"autoonoff": "Activity Planner",
			"success": "Status ok",
			"zoom": "Zoom",
			"pan": "Pan",
			"draw": "Draw",
			"move": "Move",
			"reset_zoom": "Reset zoom",
			"queued_at": "Queued At",
			"score": "Score",
			"ai_tools": "AI tools",
			"missing_symbols": "This font does not contain all symbols, the live preview and the rendered image may differ.",
			"characters": "characters",
			"recently_used": "Recently used",
			"set_background": "Set background",
			"filters": "Filters",
			"remove_background_error": "There was an error while removing the background",
			"cannot_remove_background": "We cannot reliably remove the background for this image",
			"object_to_image_ratio": "Object/image",
			"template_id": "template id",
			"disable_show_overlap": "Do not show zone in preview",
			"font_example": "The quick brown fox jumps over the lazy dog.",
			"unsupported_mime_type": "Unsupported file format",
			"unsupported_file_size": "The file is too large",
			"selection": "Selection",
			"is_transparent": "Has Alpha",
			"is_light_bg": "Light background",
			"orientation": "Image orientation",
			"portrait": "Portrait",
			"landscape": "Landscape",
			"bg_color_distance": "Color distance",
			"small_distance": "small",
			"big_distance": "big",
			"medium_distance": "medium",
			"bg_color": "Background color",
			"create": "Create",
			"create_predefined_fie_queries_title": "Which of the following fie queries do you want to create?",
			"create_predefined_fie_queries_text": "Create predefined FIE queries?",
			"active_supereffect": "Active super effect",
			"not_number": "Not a number",
			"prepared_text": "The prepared text",
			"get_now": "get now",
			"discount": "discount",
			"discount_and_frame": "Discount & frame",
			"1_plus_1_circle": "BUY 1 & GET 1 FREE",
			"buy_one_get_one_free": "buy 1 & get 1 free",
			"last_piece": "Last Piece",
			"new_year_sale": "New Year Sale",
			"free_gift": "free gift",
			"add_to_cart": "add to cart",
			"sale": "sale",
			"buy_now": "buy now",
			"buy": "buy",
			"order_now": "order now",
			"free_delivery": "free delivery",
			"newie": "new",
			"in_stock": "in stock",
			"project_health": "Project health",
			"find_by": "Find by",
			"fonts": "Fonts",
			"send_mailgun_notifications": "Send system notifications and tips to mail",
			"force_remove_alpha": "Removing the alpha channel from the image before sending it for background removal",
			"auto_template_priority": "Reorder templates automatically",
			"no_watermark_mask_defined": "First you need to define the watermark mask.",
			"brush": "Brush",
			"eraser": "Eraser",
			"main_image_opt": "Main picture",
			"layout_opt": "Layout",
			"skip_refresh_images": "Download images only when their URL changes",
			"skip_refresh_images_hint": "The storage with the images will not be loaded too much. Note however if the image url remains the same and the content changes, this change cannot be detected automatically.",
			"or": "or",
			"preferred_product_id": "Preferred ID",
			"random_product_id": "Loaded product",
			"other": "other",
			"group_all_templates": "All templates",
			"group_discounts_and_sales": "Discounts and sales",
			"group_black_friday": "Black Friday",
			"group_gift": "Free gift",
			"group_free_delivery": "Free delivery",
			"group_new_year_sale": "New Year Sale",
			"group_viva_magenta": "Viva Magenta",
			"group_midjourney": "Midjourney",
			"group_generic": "Generic templates",
			"group_new": "New arrivals",
			"group_seasonal": "Seasonal campaigns",
			"group_availability": "Stock availability",
			"group_christmas": "Christmas campaign",
			"group_effects": "Effects",
			"group_background": "Background",
			"group_warranty": "Warranty",
			"group_valentine": "Valentine's Day",
			"group_size_variant": "Size variations",
			"custom": "Custom",
			"no_watermark_groups_yet": "You don't have any watermark groups yet.",
			"no_watermark_groups_published_yet": "You have no published watermark groups yet.",
			"start_here": "Start here",
			"select_images_to_watermark_groups": "Please select several images with the same watermark.",
			"watermark_groups_info_0": "For each type of watermark, you need to mark a few images with the same watermark. These images will be used for training the model.",
			"watermark_groups_info_1": "todo",
			"images_from_mergado": "Images from MERGADO",
			"images_from_fie": "Product images from MERGADO rules",
			"images_from_upload": "Uploaded images",
			"select_images_with_same_watermark": "Select images",
			"create_watermark_mask": "Paint the watermark with a brush",
			"create_watermark_group": "Create",
			"create_new_watermark_group": "Vytvořit novou skupinu obrázků",
			"append_to_watermark_group": "Append",
			"to_wm_group": "to group",
			"add": "Add",
			"add_image": "Add image",
			"no_watermark_mask": "Please mark the watermark",
			"publish_to_trainer": "Send to trainer",
			"images_in_group": "Pictures in a group",
			"rename": "Rename",
			"group_exists": "Group already exists",
			"cannot_be_empty": "Cannot be empty",
			"sent": "Sent",
			"confirm_remove_group_image": "Delete image from watermark group?",
			"confirm_remove_group": "Delete a watermark group",
			"empty_watermark_group": "The watermark group does not contain any images. Start by uploading images to a group.",
			"unpublished_group": "The group was not sent to train the model",
			"watermark_group_hash_diff": "The group has been changed. Please re-send it for training.",
			"watermark_group_some_images_without_mask": "Some products in this group have no watermark mask.",
			"spacing": "Spacing",
			"line_spacing": "Line spacing",
			"letter_spacing": "Letter spacing",
			"lines_and_letters_spacing": "Spaces between letters",
			"publish_to_detector": "Send to watermark detector",
			"published": "Published",
			"no_gradients_yet": "You have no gradient yet",
			"results": "Results",
			"no_results_yet": "No results yet",
			"template_name_max_100": "max name length is 100 characters",
			"clockwise": "Clockwise",
			"counter_clockwise": "Counter clockwise",
			"no_color": "none",
			"text_stroke": "Text stroke",
			"text_stroke_underlayer": "Outline as background (text thickness remains unchanged)",
			"text_stroke_inside": "Outline around the text at the expense of text thickness",
			"text_padding": "Text padding",
			"select_format_to_see_templates": "To view graphic templates, first select the output image format.",
			"warn_inactive_fie_queries": "These predefined selections are not active",
			"warn_rules_not_applied_yet": "These queries are not listed because the rules have not run yet",
			"random_colors": "Random colors",
			"random_gradients": "Random gradients",
			"dominant_color": "Color from product",
			"warn_transparent_background": "If you want a <b>transparent background</b> for the output images, select .png as the output format in Settings.",
			"import_palette": "Import palette",
			"delete_palette": "Delete palette",
			"add_color": "Add color",
			"group_easter_campaign": "Easter campaign",
			"happy_easter": "Veselé Velikonoce",
			"easter_discounts": "Easter discounts",
			"easters": "EASTER",
			"spring": "SPRING",
			"spring_sales": "Spring sale",
			"spring_discounts": "Spring discounts",
			"discounts": "SALES",
			"discount_30": "DISCOUNT 30%",
			"discounts_30": "DISCOUNTS -30%",
			"up_to_20": "20% OFF",
			"right": "RIGHT",
			"now": "NOW",
			"click_here": "CLICK HERE",
			"buy_here": "SHOP HERE",
			"watermark_mark_images": "Select and mark 10 to 15 images that contain the same watermark.",
			"watermark_max_images": "Max 15 images",
			"watermark_min_images": "Min 10 images",
			"marked_watermarks": "marked watermarks",
			"not_published_yet": "not published yet",
			"text_orientation": "Text orientation",
			"horizontal_orientation": "horizontally",
			"vertical_orientation": "vertically",
			"clip_mask": "Clip mask",
			"add_clip_mask": "Add clip mask",
			"invert_clip_mask": "Invert clipping mask",
			"finish": "Finish",
			"watermark_is_marked": "The watermark is marked",
			"already_used_image": "Image has already been used",
			"check_elements_title": "Checking the availability of manually entered elements",
			"some_elements_not_available": "Some of the manually entered elements seem to be unavailable. There are some suggested changes:",
			"apply_all_suggested_changes": "Apply all suggested changes",
			"apply_only_selected_changes": "Apply selected changes",
			"template_layer": "Template layer",
			"e_img_url": "Image URL element",
			"e_img_url_input": "Input image URL element",
			"e_alt_img_url": "Alternative Image URL element",
			"e_alt_img_url_input": "Alternative image input element",
			"e_item_id": "ITEM ID element",
			"e_name": "Product name element",
			"e_productno": "Product number element",
			"e_price_vat": "Price element",
			"e_url": "Shop url element",
			"e_ean": "EAN element",
			"template": "template",
			"layer": "layer",
			"audit_promo_templates": "Audit promo templates",
			"save_and_rerender_promo": "Save and re-render promo for existing projects",
			"reload_saved": "Reload saved",
			"back_to_predefined": "Back to predefined",
			"reset_filters": "Reset filters",
			"has_complex_background": "Complex background",
			"complex_background_threshold": "complex background threshold",
			"empty_background_probability": "empty background probability",
			"object_bounding_box_to_image_ratio": "object bounding box to image ratio",
			"set_template_size": "Set template size (recommended)",
			"keep_original_image_size": "Keep original image size",
			"no_template_size_is_selected_title": "Template size is not set",
			"no_template_size_is_selected": "You have no size selected. If you more layers in the template, the layers may be out of the visible area.",
			"gradient_stop_points": "gradient stop-points",
			"is_autocrop": "Autocrop",
			"new_alternative_template": "New alternate images template",
			"alternative_template": "Alternative images template",
			"alternative_templates": "Alternative images templates",
			"main_templates": "Main image templates",
			"image_offset": "Image offset relatively to the layout image shape",
			"collage_image_shape": "Shape",
			"rect": "Rectangle",
			"ellipse": "Ellipse",
			"selected": "Selected",
			"import": "Import",
			"no_templates_found": "No templates found",
			"auto_priority": "Reorder automatically",
			"manual_priority": "Reorder manually",
			"right_now": "SHOP NOW",
			"limited_offer": "LIMITED OFFER",
			"sale2": "SALE",
			"sales_up_to_50": "UP TO 50%",
			"sale_up_to_50": "UP TO 50%",
			"sales_up_to": "SALE",
			"this_week": "THIS WEEK",
			"shop_here": "buy here",
			"discounts2": "DISCOUNTS",
			"textInsideShape": "Text inside shape",
			"element_not_selected": "no element selected",
			"invalid_color": "invalid color",
			"invalid_email": "invalid email",
			"letter_case": "Letter case",
			"keep": "keep",
			"to_upper_case": "to upper case",
			"to_lower_case": "to lower case",
			"first_letter_to_upper_case": "first letter to upper case",
			"first_letter_to_lower_case": "first letter to lower case",
			"first_word_letter_to_upper_case": "first word letter to upper case",
			"has_person": "A person in the picture",
			"person_detected": "has person",
			"person_not_detected": "person not detected",
			"columns": "Columns",
			"is_keep_size": "Keep the original format",
			"is_keep_size_info": "You have selected to keep the original dimensions. Cannot insert layers, only effects.",
			"contact_email": "Contact email",
			"element_short_item_id": "ITEM_ID",
			"element_short_url": "URL",
			"element_short_cpc": "CPC",
			"element_short_name": "NAME",
			"element_short_img_url": "IMG_URL",
			"element_short_img_url_input": "IMG_URL",
			"element_short_alt_img_url": "IMG_ALTERNATIVE",
			"element_short_alt_img_url_input": "IMG_ALTERNATIVE",
			"element_short_price_vat": "PRICE_VAT",
			"element_short_delivery_date": "DELIVERY_DATE",
			"element_short_manufacturer": "MANUFACTURER",
			"element_short_categorytext": "CATEGORY",
			"element_short_ean": "EAN",
			"steps_first_perex": "<h4>Welcome to the Feed Image Editor extension</h4><p class='perex'>We will help you quickly and easily edit product images for your e-shop. To ensure everything works correctly, we will set up a few basic steps together.</p>",
			"steps_last_perex": "Now you can jump into improving your product images. Select which editing you'd like to begin with in your initial template.",
			"steps_first_header": "Check the elements in your Mergado feed",
			"steps_first_subheader": "Before you start creating your first template or campaign, make sure we have correctly selected the key elements from your product feed. These are used to ensure that the correct information such as price, name, brand, or availability is added to the images.",
			"steps_need_inspiration_perex": "Check out these templates we've prepared for you.",
			"steps_need_inspiration": "Need inspiration?",
			"first_steps_title": "First setup guide",
			"steps_third": "Let's keep in touch",
			"steps_third_subscribe": "I also subscribe to the newsletter",
			"create_first_template": "Create first template",
			"steps_create_blank": "Add graphics and CTA",
			"steps_create_resize": "Resize images to suit specific format",
			"steps_create_upscale": "Enhance the quality",
			"steps_create_bg_removal": "Crop background",
			"steps_create_watermarks": "Erase image watermarks",
			"steps_create_header": "Ready to go! You can start creating",
			"steps_create_perex": "Everything is ready. You can now start editing your product images and creating your first templates.",
			"steps_who_are_you_title": "To recommend the right features and settings for you, tell us who you are.",
			"steps_who_are_you_subtitle": "This way, we will set up the services exactly tailored to your needs.",
			"steps_categorization_title": "What type of online store do you run?",
			"steps_categorization": "Select the category that best matches your assortment. Your answer will help us provide you with better, tailor-made services.",
			"steps_third_email": "Your e-mail address",
			"steps_third_sublabel": "We will send you system notifications whenever something important happens.",
			"steps_second": "Output settings",
			"output_image_format_sublabel": "Select the output image format.",
			"output_image_compression_sublabel": "Compression quality level setting.",
			"auto_compression_to_size_sublabel": "Data size reduction",
			"steps_third_email_sublabel": "We will send you notifications when anything important occurs.",
			"visual_similarity": "Visual similarity",
			"ai_params": "Adding parameters to products",
			"ai_params_generate": "Generate parameters from images to feed",
			"ai_params_is_running_on_background": "AI image analysis and parameter generation takes place in the background",
			"similar_images": "similar images",
			"find_similar_images": "Find similar images",
			"searching_in_progress": "Searching in progress",
			"create_list_and_publish_to_visual_similarity": "Export images in a template and find similar ones",
			"visual_similarity_last_update_at": "The visual similarity feature is currently disabled. Results are current as of ",
			"image_cannot_be_downloaded": "Image cannot be downloaded",
			"product_has_no_image": "Product has no image",
			"missing_image_element": "Missing IMG element",
			"visual_similarity_enabled": "Find similar images",
			"visual_similarity_n": "Number of similar images",
			"visual_similarity_threshold": "Similarity index",
			"visual_similarity_search_products_in": "Search similar in templates",
			"feature_enabled": "Feature is on",
			"feature_disabled": "Feature is off",
			"upload_images": "Upload images",
			"download_images": "Download images",
			"download_image": "Download image",
			"upload_image": "Upload image",
			"uploaded_images": "Uploaded pictures",
			"external_image": "Graphical elements",
			"blog_link": "https://www.feed-image-editor.com/blog",
			"please_select_templates": "Select the templates in which you want to search for similar products",
			"loading_results": "Loading results",
			"exporting": "Exporting products",
			"task_queued": "Task queued",
			"waiting_before_publish": "Waiting before publish task",
			"popup_box_header": "Important Announcement. We are changing price for Feed Image Editor",
			"popup_box_body": "<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
			"understand": "I understand",
			"rerender": "Re-render",
			"redownload": "Re-download",
			"to_be_processed": "To be processed",
			"similarity_less_than_n": "The selected number of similar images could not be found for the given product for the selected value of the similarity index. Consider reducing the similarity index value.",
			"similarity_n_limit_info": "Set the number of similar images to be searched for the given product. Some products may not necessarily be searched for this number at a given similarity index value. In this case, consider reducing the similarity index value.",
			"similarity_threshold_info": "The similarity index determines how similar images are to be searched for the product. The higher the value, the more similar the images. A value of 1 will find exactly the same images.",
			"fill_similarity_title": "Export results to the output feed",
			"fill_similarity_ids_element": "IDs of visually similar products",
			"fill_similarity_image_urls_element": "URL addresses of visually similar images",
			"no_items_filtered": "We did not find any selection",
			"no_match_with_element_regexp": "The element does not match the rule application element filter (element_regex)",
			"advanced_settings": "Advanced settings",
			"mergado_max_payload_size": "Maximum number of characters sent in one data request. Maximum possible value is 15 000 000 characters.",
			"mergado_element_regex": "Regular expression according to which the project elements will be filtered",
			"mergado_xml_equivalent": "Mergado XML elements whose equivalent for the given format will be sent from Mergado.",
			"suggested_elements_to_be_excluded": "Suggested elements you can omit when applying the rules",
			"alt_levels": "Alternative template image levels",
			"levels": "Application levels",
			"assigned_templates": "Assigned main templates",
			"no_assigned_templates": "No assigned templates",
			"necessary": "Necessary",
			"exclude_some": "Exclude some",
			"regexp": "Regular expression",
			"mergado_apply_elements": "Which elements should be sent to the FIE when applying the rules",
			"necessary_elements": "Elements necessary for the operation of FIE",
			"selected_mergado_equivalent": "Selected equivalents of Mergado elements",
			"categories": "Categories",
			"fashion": "Fashion",
			"beauty": "Beauty",
			"health": "Health",
			"pets": "Pets",
			"electronics": "Electronics",
			"home_and_garden": "Home and garden",
			"kids": "Kids",
			"sports": "Sports",
			"books": "Books",
			"cars": "Cars",
			"services_and_experiences": "Services and experiences",
			"other_category": "Other",
			"back_to_original": "Back to the original",
			"paint_transparent": "Remove background",
			"waiting_for_product_to_be_loaded": "Waiting for product to be loaded",
			"should_rerender": "Should re-render",
			"should_redownload": "Should redownload",
			"has_alt_images": "Has alternative images",
			"anim-gif": "Anim GIF",
			"auto-wmremove": "Watermarks removal",
			"format_preset": "Pre-prepared",
			"format_original": "Original",
			"format_custom": "Custom",
			"turned_off": "turned off",
			"mode": "mode",
			"inpainting_create_mask": "Mark the areas for inpainting.",
			"inpainting_how_to_deal_with_diff_size": "How to deal with the different mask and image sizes",
			"position_relative_to": "Position relative to",
			"scale_mask_to_image_size": "Scale mask to image size",
			"scale_to_size": "Scale to size",
			"object_position": "Object position",
			"complex_background": "Complex background",
			"edit_element_content": "Edit element content",
			"prefix": "prefix",
			"suffix": "suffix",
			"decimals": "decimals",
			"separator": "separator",
			"replace": "replace",
			"find_as_regexp": "find as regular expression",
			"symbol_table": "Special currency symbols",
			"find_and_replace": "Find and replace",
			"add_text": "Add text",
			"decimal_places": "Decimal places",
			"thousands_separation": "Separate thousands",
			"short_url_with_extension": "Shorter url with file extension",
			"short_url_with_extension_info": "A shorter form of the output URL address including an extension according to the output image format. Some shopping engines require an extension in the address.",
			"gradient_is_used_by_template": "This gradient is used by the template and cannot be deleted.",
			"no_search_image_results": "No images were found matching the search term.",
			"import_from_project": "Import from project",
			"choose_project": "Choose project",
			"no_other_projects_of_user": "No projects to import from.",
			"loading_queries": "Loading queries from Mergado",
			"loading_template": "Loading template",
			"text_mode": "Text mode",
			"total_icons": "Total",
			"try_icons": "Try out the icons",
			"icon_color": "Icon color",
			"did_not_found_stickers": "Didn't find the right stickers?",
			"ai_elements_to_feed": "Feed AI enrichment",
			"mcp": "MCP",
            }
        }
    